export default __webpack_public_path__ + "static/media/Travel_00.5fa7ebdf.png";